import { Invoice } from '../../domain/entities/Invoice';
import { InvoiceRepository } from '../../domain/repositories/InvoiceRepository';

/**
 * Servicio para la gestión de facturas
 */
export class InvoiceService {
  private invoiceRepository: InvoiceRepository;
  
  /**
   * Constructor del servicio de facturas
   * @param invoiceRepository - Repositorio de facturas a utilizar
   */
  constructor(invoiceRepository: InvoiceRepository) {
    this.invoiceRepository = invoiceRepository;
  }
  
  /**
   * Busca una factura por su número
   * @param invoiceNumber - Número de la factura a buscar
   * @throws Error si hay un problema con la búsqueda
   * @returns La factura encontrada o null si no existe
   */
  async findInvoice(invoiceNumber: string): Promise<Invoice | null> {
    try {
      return await this.invoiceRepository.findByInvoiceNumber(invoiceNumber);
    } catch (error) {
      console.error('Error al buscar la factura:', error);
      throw new Error('Error al buscar la factura. Por favor, inténtelo de nuevo.');
    }
  }
  
  /**
   * Obtiene todas las facturas
   * @throws Error si hay un problema al obtener las facturas
   * @returns Lista de facturas
   */
  async getAllInvoices(): Promise<Invoice[]> {
    try {
      return await this.invoiceRepository.getAll();
    } catch (error) {
      console.error('Error al obtener las facturas:', error);
      throw new Error('Error al obtener las facturas. Por favor, inténtelo de nuevo.');
    }
  }
  
  /**
   * Actualiza una factura existente
   * @param invoice - Factura actualizada
   * @throws Error si hay un problema con la actualización
   * @returns La factura actualizada
   */
  async updateInvoice(invoice: Invoice): Promise<Invoice> {
    try {
      return await this.invoiceRepository.update(invoice);
    } catch (error) {
      console.error('Error al actualizar la factura:', error);
      throw new Error('Error al actualizar la factura. Por favor, inténtelo de nuevo.');
    }
  }
} 